import React, { Component } from 'react';
import moment from 'moment';
import { FormattedMessage, injectIntl } from "react-intl";
import { Alert } from 'react-bootstrap';

class DocumentDraftInfo extends Component {
    constructor(props) {
        super(props);
        if (props.isReply) {
            this.createInfoLabelResourceId = 'GENERAL.FORMS.WARNING.REPLY_CREATED';
            this.lastDraftedInfoLabelResourceId = 'GENERAL.FORMS.WARNING.REPLY_LAST_DRAFTED';
            this.lastDraftNotifiedLabelResourceId = 'GENERAL.FORMS.WARNING.REPLY_DRAFT_NOTIFIED';
        } else {
            this.createInfoLabelResourceId = 'GENERAL.FORMS.WARNING.NOTICE_CREATED';
            this.lastDraftedInfoLabelResourceId = 'GENERAL.FORMS.WARNING.NOTICE_LAST_DRAFTED';
            this.lastDraftNotifiedLabelResourceId = 'GENERAL.FORMS.WARNING.NOTICE_DRAFT_NOTIFIED';
        }
    }




    render() {
        const { documentIsFinal, createbyname, createdate, lastdraftedbyname, lastdrafteddate, lastdraftednotifiedtoname } = this.props;
        if (documentIsFinal) {
            return null;
        }
        let createInfoLabel = (!!createbyname && !!createdate) ? this.props.intl.formatMessage({ id: this.createInfoLabelResourceId }, { PERSON_NAME: createbyname, TIME_STAMP: moment(createdate).format('DD/MM/YYYY HH:mm') }) : null;
        let lastDraftedInfoLabel = (!!lastdraftedbyname && !!lastdrafteddate) ? this.props.intl.formatMessage({ id: this.lastDraftedInfoLabelResourceId }, { PERSON_NAME: lastdraftedbyname, TIME_STAMP: moment(lastdrafteddate).format('DD/MM/YYYY HH:mm') }) : null;
        let lastDraftNotifiedLabel = (!!lastdraftednotifiedtoname) ? this.props.intl.formatMessage({ id: this.lastDraftNotifiedLabelResourceId }, { PERSON_NAME: lastdraftednotifiedtoname }) : null;
        if(!createInfoLabel && !lastDraftedInfoLabel && !lastDraftNotifiedLabel) {
            return null;
        }
        return (
            <Alert variant="secondary">
                <p>
                    {
                        !!createInfoLabel && (
                            <span>{createInfoLabel}<br /></span>
                        )
                    }
                    {
                        !!lastDraftedInfoLabel && (
                            <span>{lastDraftedInfoLabel}<br /></span>
                        )
                    }
                    {
                        !!lastDraftNotifiedLabel && (
                            <span>{lastDraftNotifiedLabel}<br /></span>
                        )
                    }
                </p>
            </Alert>

        );
    }
}


export default injectIntl(DocumentDraftInfo);